
//== Handle feature flags.
//
//##

/**
 * Class for handling feature flags
 */
class DatamintsFeatureFlags {
	/**
	 * Class constructor.
	 */
	constructor() {
		// Prevent adding new feature flags at runtime by sealing it.
		this.flags = Object.seal({
			imagesWithoutAlt: false,
		});
	}

	/**
	 * Toggle a flag.
	 *
	 * @param {string} flag Name of the flag
	 */
	toggle(flag) {
		if (this.flags.hasOwnProperty(flag)) {
			// Toggle the flag.
			this.flags[flag] = !this.flags[flag];
			console.log(`Flag ${flag} toggled to "${this.flags[flag] ? 'true' : 'false'}"`);

			// Handle any effects.
			switch (flag) {
				case 'imagesWithoutAlt':
					const classList = document.querySelector('html').classList;
					this.flags[flag] ? classList.add('images-without-alt') : classList.remove('images-without-alt');
					break;
			}
		}
		else {
			console.error(`Flag "${flag}" not found`);
		}
	}
}

window.datamintsFeatureFlags = new DatamintsFeatureFlags();
